exports.components = {
  "component---src-templates-content-tsx": () => import("./../../../src/templates/Content.tsx" /* webpackChunkName: "component---src-templates-content-tsx" */),
  "component---src-templates-home-tsx": () => import("./../../../src/templates/Home.tsx" /* webpackChunkName: "component---src-templates-home-tsx" */)
}

